import React from "react";
import { Button, Icon } from "semantic-ui-react";

const SummaryButton = (props) => {
  const {
    size,
    disabled,
    className,
    compact,
    content,
    onClick,
    fluid,
    active,
    floated,
  } = props;
  return (
    <Button
      fluid={fluid !== null ? fluid : true}
      floated={floated}
      compact={compact !== null ? compact : true}
      color="blue"
      icon
      size={size || "mini"}
      content={content}
      disabled={disabled}
      onClick={onClick}
      className={className}
    >
      <Icon name="pin" rotated={!active ? "clockwise" : null} /> {content}
    </Button>
  );
};

export default SummaryButton;
